import request from '@/api/base'

const getAppNewsList = (params) => {
  return request.post('/ipark-web/rest/open/getAppNewsList', params)
}

const getBannerManageList = (params) => {
  return request.post('/ipark-admin/banner/listBannerPage', params)
}

const getTodoList = (params) => {
  return request.post('/portal/message/queryList', params)
}
const queryMessage = (params) => {
  return request.post('/ipark-web/rest/open/messagepush/queryMessage', params)
}
// 首页消息滚动接口
const selectNewestMessage = (params) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    return request.post('/messageSendTemp/selectNewestMessage', params)
  } else {
    return request.post('/dcits-consumption/messageSendTemp/selectNewestMessage', params)
  }
}
const selectByCreateDescThree = (params) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    return request.post('/bannerTemp/selectByCreateDescThree', params)
  } else {
    return request.post('/dcits-consumption/bannerTemp/selectByCreateDescThree', params)
  }
}

const getAppNewsListRest = (params) => {
  return request.post('/ipark-web/rest/open/getAppNewsList', params)
}
const menuTop = (params) => {
  return request.get('/portal/menu/top', {params})
}
const menuMark = (params) => {
  return request.get('/portal/menu/mark', {params})
}
const menuClickNum = (params) => {
  return request.get('/portal/menu/click', {params})
}
const getParkCompanyDepartmentAndUserInfo = (params) => {
  return request.post('/portal/department/getParkCompanyDepartmentAndUserInfo', params)
}

const getDepartmentUserInfo = (params) => {
  return request.post('/portal/department/getDepartmentUserInfo', params)
}
const queryUserInfo = (params) => {
  return request.post('/portal/userInfo/queryUserinfo', params)
}
const updateSaveButlers = (params) => {
  return request.post('/portal/commercialProjectPeople/saveButlers', params)
}

const selectBillByProcessInstanceId = (params) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    return request.get('/reminderLetters/selectBillByProcessInstanceId', {params})
  } else {
    return request.get('/dcits-consumption/reminderLetters/selectBillByProcessInstanceId', {params})
  }
}

const updateMsgIsRead = (params) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    return request.get('/invEnterprise/updateMsgIsRead', {params})
  } else {
    return request.get('/dcits-consumption/invEnterprise/updateMsgIsRead', {params})
  }
}
export default {
  updateMsgIsRead,
  selectBillByProcessInstanceId,
  updateSaveButlers,
  queryUserInfo,
  getDepartmentUserInfo,
  getParkCompanyDepartmentAndUserInfo,
  getAppNewsListRest,
  selectByCreateDescThree,
  selectNewestMessage,
  queryMessage,
  getTodoList,
  getAppNewsList,
  getBannerManageList,
  menuTop,
  menuMark,
  menuClickNum
}



// WEBPACK FOOTER //
// ./src/area-contract/api/dcitsHome.js